import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { SearchService } from './search.service';
import { CompanyService } from '../companies/company.service';
import { ContactService } from '../contacts/contact.service';
import { Contact } from '../contacts/contact.model';
import { Company } from '../companies/company.model';
import { Subscription } from 'rxjs/Subscription';


import {
  debounceTime
} from 'rxjs/operators';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'
  ]
})
export class SearchComponent implements OnInit, OnDestroy {

  keepSubscriptionsAlive: boolean = true;
 
  constructor(
    public searchService: SearchService,
  ) { }

  ngOnInit() {

  }

  ngOnDestroy() {

  }


}



// WEBPACK FOOTER //
// ./client/app/features/search/search.component.ts